import { styled, Tooltip, Typography, withStyles } from "@material-ui/core";

export const CarouselText = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  marginBottom: theme.spacing(2),
}));

export const CarouselContent = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
}));

export const CarouselContainer = styled("div")({
  position: "relative",
  width: "100%",
  height: "100%",

  "& .slick-track": {
    alignSelf: "center",
    display: "flex",
    alignItems: "center",
  },
});

export const InfoTooltipContainer = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "-1.75rem",
  marginBottom: theme.spacing(1),
  justifyContent: "flex-end",
  cursor: "pointer",
  display: "flex",
  width: "100%",
}));



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/EnergyCarousel/EnergyCarousel.styles.js